// api/upahTukang.js
import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

// ============================================================
// GET - Get All Upah Tukang
// ============================================================
export const getAllUpahTukang = async (params = {}) => {
    try {
        const { page = 1, limit = 10, bantuanId, search } = params;
        const queryParams = new URLSearchParams();
        
        if (page) queryParams.append('page', page);
        if (limit) queryParams.append('limit', limit);
        if (bantuanId) queryParams.append('bantuanId', bantuanId);
        if (search) queryParams.append('search', search);
        
        const response = await axios.get(`/upah-tukang?${queryParams.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error getAllUpahTukang:', error);
        throw error;
    }
};

// ============================================================
// GET - Get Upah Tukang by ID
// ============================================================
export const getUpahTukangById = async (id) => {
    try {
        const response = await axios.get(`/upah-tukang/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error getUpahTukangById:', error);
        throw error;
    }
};

// ============================================================
// GET - Get Upah Tukang by Bantuan ID
// ============================================================
export const getUpahTukangByBantuan = async (bantuanId) => {
    try {
        const response = await axios.get(`/upah-tukang/bantuan/${bantuanId}`);
        return response.data;
    } catch (error) {
        console.error('Error getUpahTukangByBantuan:', error);
        throw error;
    }
};

// ============================================================
// GET - Get Total Upah by Bantuan ID
// ============================================================
export const getTotalUpahByBantuan = async (bantuanId) => {
    try {
        const response = await axios.get(`/upah-tukang/bantuan/${bantuanId}/total`);
        return response.data;
    } catch (error) {
        console.error('Error getTotalUpahByBantuan:', error);
        throw error;
    }
};

// ============================================================
// POST - Create Upah Tukang
// ============================================================
export const createUpahTukang = async (data) => {
    try {
        const formData = new FormData();
        formData.append('bantuanId', data.bantuanId);
        formData.append('tahap', data.tahap);
        formData.append('nominal', data.nominal);
        if (data.keterangan) formData.append('keterangan', data.keterangan);
        if (data.foto_kwitansi) formData.append('foto_kwitansi', data.foto_kwitansi);

        const response = await axios.post('/upah-tukang', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    } catch (error) {
        console.error('Error createUpahTukang:', error);
        throw error;
    }
};

// ============================================================
// PUT - Update Upah Tukang
// ============================================================
export const updateUpahTukang = async (id, data) => {
    try {
        const response = await axios.put(`/upah-tukang/${id}`, {
            nominal: data.nominal,
            keterangan: data.keterangan || ''
        });
        return response.data;
    } catch (error) {
        console.error('Error updateUpahTukang:', error);
        throw error;
    }
};

// ============================================================
// DELETE - Delete Upah Tukang
// ============================================================
export const deleteUpahTukang = async (id) => {
    try {
        const response = await axios.delete(`/upah-tukang/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleteUpahTukang:', error);
        throw error;
    }
};

// ============================================================
// POST - Upload Foto Kwitansi
// ============================================================
export const uploadFotoKwitansi = async (upahTukangId, file) => {
    try {
        const formData = new FormData();
        formData.append('foto_kwitansi', file);
        
        const response = await axios.post(
            `/upah-tukang/${upahTukangId}/foto-kwitansi`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error uploadFotoKwitansi:', error);
        throw error;
    }
};

// ============================================================
// DELETE - Delete Foto Kwitansi
// ============================================================
export const deleteFotoKwitansi = async (id) => {
    try {
        const response = await axios.delete(`/upah-tukang/foto-kwitansi/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleteFotoKwitansi:', error);
        throw error;
    }
};

// ============================================================
// GET - Get File URL Helper
// ============================================================
export const getFotoKwitansiUrl = (filename) => {
    if (!filename) return '';
    if (filename.startsWith('http')) return filename;
    return `${BASE}/files/kwitansi-upah/${filename}`;
};